import React from 'react';
import { PerformanceScan } from '../../../../fetch/fetchScanPerformance';
import { ConfettiIcon } from '../ConfettiIcon';
import './CelebrateLeader.scss';

export function CelebrateLeader({
  performanceScanList,
}: {
  performanceScanList: PerformanceScan[];
}): JSX.Element {
  if (performanceScanList && performanceScanList.length > 0) {
    const leader: PerformanceScan = performanceScanList[0];
    return (
      <div className="celebrateLeaderDiv">
        <div className="positionBox">
          <div className="confetti">
            <ConfettiIcon />
          </div>
          <div className="positionText">
            <div className="leaderName">
              {`${leader.firstName} ${leader.lastName}`}
            </div>
            <div className="leaderText"> {'is in the lead!'}</div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="celebrateLeaderDiv">
        <div className="positionBox">
          <div className="confetti">
            <ConfettiIcon />
          </div>
          <div className="positionText">
            <div className="leaderName">{`Start scanning!`}</div>
          </div>
        </div>
      </div>
    );
  }
}
